require('./brokerHirePensionPlanView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @actions
const brokerPensionPlansActions = require('actions/brokerPensionPlans');
const brokerHirePensionPlanActions = require('actions/brokerHirePensionPlan');
const profileActions = require('actions/profile');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');
const brokerPensionPlanPeriodicalContributionActions = require('actions/brokerPensionPlanPeriodicalContribution');
const BrokerStocksByTypeActions = require('actions/brokerStocksByType');
const BlockedAccounts = require('actions/blockedAccounts');
const brokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');

// @ commons
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const BrokerPensionPlanHeader = require('components/broker/brokerPensionPlanHeader/brokerPensionPlanHeader');
const BrokerHirePensionPlan = require('components/broker/brokerHirePensionPlan/brokerHirePensionPlan');
const BrokerHirePensionPlanError = require('components/broker/brokerHirePensionPlan/brokerHirePensionPlanError/brokerHirePensionPlanError');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { ModalUsPersonBlock } = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');

// @constants
const { HIRE_PENSION_PLAN } = require('constants/operationCodesAccounts');
const {
    MYPROFILE_BROKER_EXPLORE_PLANS_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    BROKER_HIRE_PENSION_PLAN_HAS_PERIODICAL_CONTRIB,
    BROKER_HIRE_PENSION_PLAN_IS_IN_WALLET,
    FIRST_STEP,
    BROKER_PG_URL
} = require('constants/index');
const { WEALTH_SEPBLAC_BLOCKED_ACCOUNTS } = require('constants/flagBasedFeatures');


// @Contact Center constants
const {
    PENSION_PLAN_STANDARD,
    PENSION_PLAN_PRODUCT_TYPE,
    PENSION_PLAN_PRODUCT_SUB_TYPE,
} = require('constants/contactCenter/pensionPlans');

// @Contact Center;
const NextButtonWrapper = require("components/contactCenter/nextButtonWrapper/nextButtonWrapper");
const { PensionPlanLegalConfirmation } = require('components/contactCenter/brokerLegalConfirmation/pensionPlanLegalConfirmation/pensionPlanLegalConfirmation');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');

class BrokerHirePensionPlanView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayWizard: !__CONTACT_CENTER__,
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY
        };

        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);
        this.handleShowWizard = this.handleShowWizard.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleAccountNumberChange = this.handleAccountNumberChange.bind(this);
        this.handleIntervenersChange = this.handleIntervenersChange.bind(this);
    }

    componentWillMount() {
        const {
            immAccounts,
            getBlockedAccounts,
            requestPensionPlan,
            requestAccounts,
            getPeriodicalContribution,
            resetPeriodicalContribution,
            isPlanInWallet,
            getStocksByType,
            immBrokerMyInvestments,
            match: { params: { planId } },
            history,
            getBlockedAccountBySepblac,
            flagBasedFeatures,
        } = this.props;
        
        if (flagBasedFeatures.get(WEALTH_SEPBLAC_BLOCKED_ACCOUNTS)) {
            getBlockedAccountBySepblac(history);
        }
        getStocksByType();
        requestPensionPlan(planId);
        requestAccounts(history);
        resetPeriodicalContribution();
        getPeriodicalContribution(planId);
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_PENSION_PLAN);

        if (immBrokerMyInvestments.get('fetchSuccess')) {
            isPlanInWallet(planId);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immBrokerMyInvestments, match: { params: { planId } } } = this.props;
        if (nextProps.immBrokerMyInvestments.get('fetchSuccess') !== immBrokerMyInvestments.get('fetchSuccess')) {
            this.props.isPlanInWallet(planId);
        }
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetPlan();
        this.props.clearSearchResults();
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            selectedLegalConfirmationValue: value
        });
    }

    handleShowWizard() {
        this.setState({
            displayWizard: true,
        })
    }

    buildHeader() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: formatText(`breadcrumb-hirePensionPlans`),
                url: ''
            }
        ];
        return (
            <OKCover size="medium" section="broker" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle(formatText(`breadcrumb-hirePensionPlans`))}>
                    <OKButton
                        inverse={true}
                        modifier="ghost"
                        to={MYPROFILE_BROKER_EXPLORE_PLANS_URL}
                    >
                        <FormattedText value="broker-goToAdvancedSearch" />
                    </OKButton>
                </OKHeaderSubPage>
            </OKCover>
        );
    }

    buildHirePensionPlanBody() {
        const {
            immAccounts,
            immHirePensionPlan,
            immPensionPlan,
            immBrokerPensionPlanPeriodicalContribution,
            match: { params: { planId } },
            setAnnualIncrement,
            setAnnualIncrementPercentage,
            setAuthorization,
            setDate,
            setEmail,
            setEmailRadio,
            setInitialContribution,
            setPeriodicity,
            setPeriodicityAmount,
            setVisibleStep,
            setWillCancel,
            validateStep,
            onToggleDisclaimer,
            immProfile,
            setContributionAnswer,
            setDocumentsRead,
            immBrokerProductAdvancedSearch
        } = this.props;

        const immBlockedAccountsIds = immAccounts.get('blockedAccountsIds');
        let hirePensionPlanBody;
        let legalConfirmation;
        if (__CONTACT_CENTER__ && !this.state.displayWizard && !immHirePensionPlan.get('submitSuccessful')) {
            legalConfirmation = this.buildNextButtonWrappedLegalConfirmation();
        }
        if (immBrokerPensionPlanPeriodicalContribution.get('success')) {
            if (immHirePensionPlan.get('isPlanInWallet')) {
                const isPlanActiveInPeriodicalPlans = immHirePensionPlan.get('isActiveInPeriodicalPlans');

                if (!isPlanActiveInPeriodicalPlans) {
                    hirePensionPlanBody = (
                        <BrokerHirePensionPlanError
                            errType={BROKER_HIRE_PENSION_PLAN_IS_IN_WALLET}
                            planId={planId}
                        />
                    );
                } else {
                    hirePensionPlanBody = (
                        <BrokerHirePensionPlanError
                            errType={BROKER_HIRE_PENSION_PLAN_HAS_PERIODICAL_CONTRIB}
                            planId={planId}
                        />
                    );
                }
            } else {
                hirePensionPlanBody = [
                    legalConfirmation,
                    this.state.displayWizard && <BrokerHirePensionPlan
                        onAccountChange={this.handleAccountNumberChange}
                        onAnnualIncrementChange={setAnnualIncrement}
                        onAnnualIncrementPercentageChange={setAnnualIncrementPercentage}
                        onAuthorizationChange={setAuthorization}
                        onDateChange={setDate}
                        onEmailChange={setEmail}
                        onEmailRadioChange={setEmailRadio}
                        onInitialContributionChange={setInitialContribution}
                        onPeriodicityAmountChange={setPeriodicityAmount}
                        onPeriodicityChange={setPeriodicity}
                        immAccounts={immAccounts}
                        immHirePensionPlan={immHirePensionPlan}
                        immPensionPlan={immPensionPlan}
                        onCancel={() => this.handleCancel()}
                        onFinish={this.handleFinish}
                        setVisibleStep={setVisibleStep}
                        setWillCancel={setWillCancel}
                        validateStep={validateStep}
                        onToggleDisclaimer={onToggleDisclaimer}
                        immProfile={immProfile}
                        setContributionAnswer={setContributionAnswer}
                        onIntervenersChange={this.handleIntervenersChange}
                        setDocumentsRead={setDocumentsRead}
                        immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                        blockedAccountsIds={immBlockedAccountsIds}
                    />
                ];
            }
        } else {
            hirePensionPlanBody = <LoadingSection />;
        }

        return hirePensionPlanBody;
    }

    handleAccountNumberChange(accountNumber) {
        const { setAccountNumber, requestInterveners, history } = this.props;
        setAccountNumber(accountNumber);
        if (accountNumber) {
            requestInterveners(accountNumber, history);
        }
    }

    handleIntervenersChange() {
        const { immHirePensionPlan, immProfile, setIntervener } = this.props;
        const intervenersOptions = immHirePensionPlan.getIn(['steps', FIRST_STEP, 'formatedInterveners']);
        const hasSelectedValue = intervenersOptions.size > 0;

        if (hasSelectedValue) {
            const profileUserNumber = immProfile.getIn(['codigoPersona', 'f']);
            const selectedValue = intervenersOptions.find(intervener => profileUserNumber === intervener.value);
            if (selectedValue !== undefined) {
                setIntervener(selectedValue);
            }
        }
    }

    handleCancel() {
        const url = '/myprofile/broker/general';
        this.props.history.push(url)
    }

    handleFinish() {
        this.props.hirePensionPlan(this.props.history);
    }

    buildNextButtonWrappedLegalConfirmation() {

        const {
            immPensionPlan,
            immProfileFields,
            requestProfile,
            resetPrecontractualMail,
            sendPreContractualMail,
            immPreContractualMail,
        } = this.props;

        const {
            selectedLegalConfirmationValue,
        } = this.state;

        const { name, dgscode, secId } = immPensionPlan.get('pensionPlan').toJS();

        const sendMailParams = {
            productName: name,
            standar: PENSION_PLAN_STANDARD,
            type: PENSION_PLAN_PRODUCT_TYPE,
            subType: PENSION_PLAN_PRODUCT_SUB_TYPE,
        };

        const isAbleToContinueToWizard = immPreContractualMail.get('mailSent') && selectedLegalConfirmationValue === SELECTED_VALUES.YES && !immProfileFields.get('error');

        return (
            <article className="content-box broker-hire-pension-plan__legal-confirmation" id="printable-wizard">
                <NextButtonWrapper
                    canContinue={isAbleToContinueToWizard}
                    onContinue={this.handleShowWizard}
                >
                    <PensionPlanLegalConfirmation
                        planDgsCode={dgscode}
                        planSecId={secId}
                        pensionPlanFullName={name}
                        requestProfile={requestProfile}
                        immProfileFields={immProfileFields}
                        onYesNoOptionChange={this.handleLegalYesNoOptionChange}
                        selectedYesNoOption={this.state.selectedLegalConfirmationValue}
                        sendMail={sendPreContractualMail}
                        resetMailState={resetPrecontractualMail}
                        immPreContractualMail={immPreContractualMail}
                        sendMailParams={sendMailParams}
                    />
                </NextButtonWrapper>
            </article>
        );
    }

    buildContent() {
        const {
            immBrokerProductAdvancedSearch,
            immPensionPlan
        } = this.props;
        const header = this.buildHeader();
        const notFound = immPensionPlan.get('notFound');
        let content = <LoadingSection />;
        if (!immPensionPlan.get('pensionPlan').isEmpty()) {
            content = (
                <div>
                    <div className="container-fluid card-details--header-identifier">
                        <div className="row">
                            {header}
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-12">
                                    <BrokerPensionPlanHeader
                                        immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                                        immPensionPlan={immPensionPlan}
                                    />
                                    {this.buildHirePensionPlanBody()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if (notFound) {
            const notFoundText = formatText('brokerHirePlans-notFound');
            content = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            {header}
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-positive">
                                <div className="col-xs-12">
                                    <EmptyState primaryText={notFoundText} iconType="noitems-wealth" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }

    render() {
        const {
            flagBasedFeatures,
            history,
            immAccounts,
        } = this.props;

        if (immAccounts.get('isFetchingBlockedAccountBySepblac')) {
            return <LoadingSection />;
        }

        const ffUsPersonOpenBrokerageAccount = flagBasedFeatures.get('wealth_pension_plans_hire_us_person');
        const content = this.buildContent();
        
        return (
            <ModalUsPersonBlock
                children={content}
                featureFlag={ffUsPersonOpenBrokerageAccount}
                titleKey={"us_person_popup-pension_plans_hire_block_title"}
                description={"us_person_popup-pension_plans_hire_block_message"}
                buttonClick={() => history.push(BROKER_PG_URL)}
            />
        );
    }
}

BrokerHirePensionPlanView.propTypes = {
    hirePensionPlan: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immBrokerPensionPlanPeriodicalContribution: PropTypes.object.isRequired,
    immHirePensionPlan: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired,
    isPlanInWallet: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestAccounts: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    requestPensionPlan: PropTypes.func.isRequired,
    getPeriodicalContribution: PropTypes.func.isRequired,
    resetPeriodicalContribution: PropTypes.func.isRequired,
    setAccountNumber: PropTypes.func.isRequired,
    setAnnualIncrement: PropTypes.func.isRequired,
    setAnnualIncrementPercentage: PropTypes.func.isRequired,
    setDate: PropTypes.func.isRequired,
    setInitialContribution: PropTypes.func.isRequired,
    setIntervener: PropTypes.func.isRequired,
    setIntervenerLabel: PropTypes.func,
    setPeriodicity: PropTypes.func.isRequired,
    setPeriodicityAmount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setAuthorization: PropTypes.func,
    setEmailRadio: PropTypes.func,
    setEmail: PropTypes.func,
    validateStep: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetPlan: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    onToggleDisclaimer: PropTypes.func.isRequired,
    immProfile: PropTypes.object,
    setContributionAnswer: PropTypes.func.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func,
    clearSearchResults: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    getBlockedAccountBySepblac: PropTypes.func,
};

module.exports.constructor = BrokerHirePensionPlanView;

module.exports.BrokerHirePensionPlanView = connect(state => ({
    immAccounts: state.accounts,
    immBrokerMyInvestments: state.brokerMyInvestments,
    immBrokerPensionPlanPeriodicalContribution: state.brokerPensionPlanPeriodicalContribution,
    immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
    immHirePensionPlan: state.brokerHirePensionPlan,
    immPensionPlan: state.brokerPensionPlans,
    immProfileFields: state.profile,
    immPreContractualMail: state.preContractualMail,
    immProfile: state.profile,
    flagBasedFeatures: state.flagBasedFeatures,
}), {
    hirePensionPlan: brokerHirePensionPlanActions.hirePensionPlan,
    isPlanInWallet: brokerHirePensionPlanActions.isPlanInWallet,
    requestAccounts: brokerHirePensionPlanActions.requestAccounts,
    requestInterveners: brokerHirePensionPlanActions.requestInterveners,
    requestPensionPlan: brokerPensionPlansActions.requestPensionPlan,
    getPeriodicalContribution: brokerPensionPlanPeriodicalContributionActions.getPeriodicalContribution,
    reset: brokerHirePensionPlanActions.reset,
    resetPlan: brokerPensionPlansActions.reset,
    resetPeriodicalContribution: brokerPensionPlanPeriodicalContributionActions.resetPeriodicalContribution,
    setAccountNumber: brokerHirePensionPlanActions.setAccountNumber,
    setAnnualIncrement: brokerHirePensionPlanActions.setAnnualIncrement,
    setAnnualIncrementPercentage: brokerHirePensionPlanActions.setAnnualIncrementPercentage,
    setAuthorization: brokerHirePensionPlanActions.setAuthorization,
    setDate: brokerHirePensionPlanActions.setDate,
    setEmail: brokerHirePensionPlanActions.setEmail,
    setEmailRadio: brokerHirePensionPlanActions.setEmailRadio,
    setInitialContribution: brokerHirePensionPlanActions.setInitialContribution,
    setIntervener: brokerHirePensionPlanActions.setIntervener,
    setIntervenerLabel: brokerHirePensionPlanActions.setIntervenerLabel,
    setPeriodicity: brokerHirePensionPlanActions.setPeriodicity,
    setPeriodicityAmount: brokerHirePensionPlanActions.setPeriodicityAmount,
    setVisibleStep: brokerHirePensionPlanActions.setVisibleStep,
    setWillCancel: brokerHirePensionPlanActions.setWillCancel,
    setWillLeave: brokerHirePensionPlanActions.setWillLeave,
    validateStep: brokerHirePensionPlanActions.validateStep,
    onToggleDisclaimer: brokerHirePensionPlanActions.toggleDisclaimer,
    requestProfile: profileActions.requestProfile,
    sendPreContractualMail: preContractualMailInfoActions.sendPlansPreContractualMail,
    resetPrecontractualMail: preContractualMailInfoActions.resetPrecontractualMail,
    setContributionAnswer: brokerHirePensionPlanActions.setContributionAnswer,
    getStocksByType: BrokerStocksByTypeActions.getStocksByType,
    setDocumentsRead: brokerHirePensionPlanActions.setDocumentsRead,
    getBlockedAccounts: BlockedAccounts.getBlockedAccounts,
    clearSearchResults: brokerProductAdvancedSearchActions.clearResults,
    getBlockedAccountBySepblac: BlockedAccounts.getBlockedAccountBySepblac,
})(withRouter(BrokerHirePensionPlanView));
